import { GridActionsCellItem, GridRowModes } from "@mui/x-data-grid";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Close";

const columnBuilder = (props) => {
  const {
    regionData,
    branchData,
    rowModesModel,
    handleEditClick,
    handleSaveClick,
    handleDeleteClick,
    handleCancelClick,
    isAdmin = false,
  } = props;

  const columns = [
    { field: "id", headerName: "ID", width: 50, editable: false },
    {
      field: "teacherName",
      headerName: "Lehrkraft *",
      type: "text",
      editable: isAdmin,
      flex: 1,
    },
    {
      field: "street",
      headerName: "Straße",
      type: "text",
      editable: isAdmin,
      flex: 1,
    },
    {
      field: "zip",
      headerName: "PLZ",
      type: "number",
      editable: isAdmin,
      width: 100,
      valueFormatter: (params) => {
        if (!params.value && params.value !== 0) return "";
        return "" + params.value;
      },
      renderCell: (params) => {
        if (!params.value && params.value !== 0) return "";
        return params.value;
      },
    },
    {
      field: "regionId",
      headerName: "Ort (Region) *",
      type: "singleSelect",
      editable: isAdmin,
      width: 120,
      getOptionValue: (region) => region?.id,
      getOptionLabel: (region) => region?.regionName,
      valueOptions: regionData,
      valueFormatter: (params) => {
        try {
          if (!params?.value || !regionData) return "";
          const region = regionData.find(
            (region) => region.id === params.value
          );
          return region?.regionName || "";
        } catch (error) {
          console.error("Region formatting error:", error);
          return "";
        }
      },
      renderCell: (params) => {
        try {
          if (!params?.value || !regionData) return "";
          const region = regionData.find(
            (region) => region.id === params.value
          );
          return region?.regionName || "";
        } catch (error) {
          console.error("Region rendering error:", error);
          return "";
        }
      },
    },
    {
      field: "branchId",
      headerName: "Abrechnungstelle *",
      type: "singleSelect",
      editable: isAdmin,
      flex: 1,
      getOptionValue: (branch) => branch?.id,
      getOptionLabel: (branch) => branch?.branchName,
      valueOptions: branchData,
      valueFormatter: (params) => {
        try {
          if (!params?.value || !branchData) return "";
          const branch = branchData.find(
            (branch) => branch.id === params.value
          );
          return branch?.branchName || "";
        } catch (error) {
          console.error("Branch formatting error:", error);
          return "";
        }
      },
      renderCell: (params) => {
        try {
          if (!params?.value || !branchData) return "";
          const branch = branchData.find(
            (branch) => branch.id === params.value
          );
          return branch?.branchName || "";
        } catch (error) {
          console.error("Branch rendering error:", error);
          return "";
        }
      },
    },
    {
      field: "tel",
      headerName: "Telefon",
      type: "text",
      editable: isAdmin,
      width: 100,
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 100,
      cellClassName: "actions",
      getActions: ({ id }) => {
        const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;

        if (isInEditMode) {
          return [
            <GridActionsCellItem
              icon={<SaveIcon />}
              label="Save"
              onClick={handleSaveClick(id)}
              disabled={!isAdmin}
            />,
            <GridActionsCellItem
              icon={<CancelIcon />}
              label="Cancel"
              className="textPrimary"
              onClick={handleCancelClick(id)}
              color="inherit"
              disabled={!isAdmin}
            />,
          ];
        }

        return [
          <GridActionsCellItem
            icon={<EditIcon />}
            label="Edit"
            className="textPrimary"
            onClick={handleEditClick(id)}
            color="inherit"
            disabled={!isAdmin}
          />,
          <GridActionsCellItem
            icon={<DeleteIcon />}
            label="Delete"
            onClick={handleDeleteClick(id)}
            color="inherit"
            disabled={!isAdmin}
          />,
        ];
      },
    },
  ];

  return columns;
};

export default columnBuilder;
